/**
 * Provides smooth scrolling for anchors, and handles moving the target below
 * the website's sticky header.
 */
import $ from "jquery";

function AnchorFix() {
  function init() {
    const stickyTitleBarOffset = $("body").hasClass("user-logged-in")
      ? 225
      : 170;
    $('a[href*="#"]:not([href="#"])').click(function () {
      if (
        window.location.pathname.replace(/^\//, "") ===
          this.pathname.replace(/^\//, "") &&
        window.location.hostname === this.hostname
      ) {
        let target = $(this.hash);
        // Confirm target is visible, use fallback option if not.
        target =
          target.length && target.is(":visible")
            ? target
            : $(`[data-target=${this.hash.slice(1)}]:visible`);
        if (target.length) {
          $("html, body").animate(
            {
              scrollTop: target.offset().top - stickyTitleBarOffset,
            },
            500,
          );
          window.location.hash = $(this).prop("hash");
          return false;
        }
      }
    });
  }

  return {
    init,
  };
}

$(function () {
  AnchorFix().init();
});
